var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleAdsPopup',{staticStyle:{"margin":"0 auto"},attrs:{"path":"/22163595876/RTBGo_Interstitial_Web","size":[1, 1],"id":"RTBGo_Interstitial_Web"}})}
var staticRenderFns = []

export { render, staticRenderFns }